module.exports = __webpack_public_path__ + "static/media/atv-ride.6573e55e.webp";